import * as React from 'react';
import withStyles from 'react-jss';
import { useInterSectionObserver } from 'src/hooks/useInterSectionObserver';
import { SearchResult } from './TypesInDiscoverRates/SearchResult';
import ChargeListCards from './ChargeListCards';

const styles = () => ({
  interSectDiv: {
    minHeight: '100px',
  },
});

interface IntersectChargeCardProps {
  classes: {
    [X in keyof ReturnType<typeof styles>]: string
  };
  domSelector: string;
  searchResult: SearchResult;
  topResult: SearchResult;
  isItemPresent: {
    isLocalsPresent: boolean;
    activeKey: string;
  };
}

const IntersectChargeListCard = ({
  classes,
  domSelector,
  searchResult,
  topResult,
  isItemPresent,
}: IntersectChargeCardProps) => {
  const [isLoaded, elRef] = useInterSectionObserver(domSelector, true);
  return (
    <div className={classes.interSectDiv} ref={elRef}>
      {isLoaded
        && <ChargeListCards
          data={searchResult}
          topResult={topResult}
          isItemPresent={isItemPresent}
        />}
    </div>
  );
};

export default withStyles(styles)(IntersectChargeListCard);
